module.exports = __webpack_public_path__ + "static/media/visible.d9e208ed.svg";